export default __webpack_public_path__ + "static/media/logo.d9aff7d1.png";